import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { ICON_HEIGHT_24 } from '../../Icon'
import { NAV_ARROWS_MIN_VALUE, NavArrows } from '../../NavArrow'

import {
  QA_NAME_NEXT_BTN,
  QA_NAME_PREV_BTN,
} from './TablePaginationNavigation.constants'
import { isTablePaginationNavigationIconShown } from './TablePaginationNavigation.utils'

import * as styles from './TablePaginationNavigation.module.css'

function TablePaginationNavigation({
  NextButton,
  PrevButton,
  children,
  disabled,
  isMobileScreenSize,
  nextButtonProps: { text: nextButtonText, ...nextButtonProps } = EMPTY_OBJECT,
  prevButtonProps: { text: prevButtonText, ...prevButtonProps } = EMPTY_OBJECT,
  value,
  onChange,
}) {
  const { page, pageCount } = value

  const { t } = useTranslation()

  function handleClickNavArrow(nextValue) {
    if (!disabled) {
      onChange({ ...value, page: nextValue })
    }
  }

  const Icon = isTablePaginationNavigationIconShown({
    isMobileScreenSize,
    nextButtonText,
  })
    ? undefined
    : null

  return (
    <NavArrows
      betweenButtonsContent={children}
      className={styles.tablePaginationNavigation}
      disabled={disabled}
      maxValue={pageCount}
      minValue={NAV_ARROWS_MIN_VALUE}
      nextActionProps={{
        ...nextButtonProps,
        ButtonComponent: NextButton,
        Icon,
        isGrey: true,
        qaName: QA_NAME_NEXT_BTN,
        size: ICON_HEIGHT_24,
        text:
          nextButtonText === null || isMobileScreenSize
            ? null
            : t('Table.NextPageBtnKey'),
      }}
      prevActionProps={{
        ...prevButtonProps,
        ButtonComponent: PrevButton,
        Icon,
        isGrey: true,
        qaName: QA_NAME_PREV_BTN,
        size: ICON_HEIGHT_24,
        text:
          prevButtonText === null || isMobileScreenSize
            ? null
            : t('Table.PreviosPageBtnKey'),
      }}
      size={ICON_HEIGHT_24}
      value={page}
      onChange={handleClickNavArrow}
    />
  )
}

export default TablePaginationNavigation
